export default __webpack_public_path__ + "static/media/screen2.ec7c9f63.png";